import type { CSSProperties } from "react";

/** Thaana script block (Dhivehi) */
const THAANA_RE = /[\u0780-\u07BF]/;

/** Served from apps/web/public/fonts/Faruma.ttf */
export const FARUMA_FONT_URL = "/fonts/Faruma.ttf";

export const FARUMA_FONT_FAMILY = "Faruma, Arial, sans-serif";

/** Faruma size for on-screen Dhivehi fields (matches PDF). */
export const FARUMA_FONT_SIZE = "12pt";

const farumaRtlBase: CSSProperties = {
  fontFamily: FARUMA_FONT_FAMILY,
  fontSize: FARUMA_FONT_SIZE,
  direction: "rtl",
  textAlign: "right",
};

/** Prefer Dhivehi name for approval/signatory display; fall back to English fullName. */
export function approvalDisplayName(user: {
  fullName?: string | null;
  fullNameDhivehi?: string | null;
} | null | undefined): string {
  if (!user) return "—";
  const dhivehi = user.fullNameDhivehi?.trim();
  if (dhivehi) return dhivehi;
  const english = user.fullName?.trim();
  if (english) return english;
  return "—";
}

export function containsThaanaScript(text: string | null | undefined): boolean {
  if (text == null || text === "") return false;
  return THAANA_RE.test(String(text));
}

/** Mantine Text / table cell style when content includes Dhivehi */
export function dhivehiDisplayStyle(text: string | null | undefined): CSSProperties | undefined {
  if (!containsThaanaScript(text)) return undefined;
  return { ...farumaRtlBase };
}

/** Single-source Dhivehi fields — always Faruma 12pt + RTL on detail/create views */
export function farumaFieldDisplayStyle(): CSSProperties {
  return { ...farumaRtlBase };
}

/** RTL layout wrapper for single-source form content blocks */
export function singleSourceRtlLayoutStyle(): CSSProperties {
  return { direction: "rtl", textAlign: "right" };
}

/** Mantine TextInput / Textarea — Faruma 12pt + RTL for Thaana keyboard fields */
export function thaanaFieldInputStyles(): { input: CSSProperties } {
  return { input: { ...farumaRtlBase } };
}

/** Mantine TextInput / Textarea `styles.input` fragment for Dhivehi */
export function dhivehiInputStyle(
  value: string | null | undefined
): Pick<CSSProperties, "fontFamily" | "fontSize" | "direction" | "textAlign"> | undefined {
  if (!containsThaanaScript(value)) return undefined;
  return {
    fontFamily: FARUMA_FONT_FAMILY,
    fontSize: FARUMA_FONT_SIZE,
    direction: "rtl",
    textAlign: "right",
  };
}
